import { registerIcons } from "./register.js";
import wheat from "./custom/wheat.js";
import shoppingBasket from "./custom/shopping-basket.js";
import idCard from "./custom/id-card.js";
import trophy from "./custom/trophy.js";
import userRound from "./custom/user-round.js";

const customIcons = [wheat, shoppingBasket, idCard, trophy, userRound];

registerIcons(customIcons);
